import axios from 'axios';
const base = process.env.REACT_APP_BASE_URL.replace(/\/+$/, '') + '/offline-monitor';
const options = () => ({ headers: { Authorization: localStorage.getItem('adminToken') || '' } });
async function get(path, params) {
  const response = await axios.get(base + path, { ...options(), params });
  if (response.data.status !== 'SUCCESS') throw new Error(response.data.message || 'Offline monitoring request failed');
  return response.data.data;
}
export default {
  credentials: () => get('/credential-branches'),
  saveCredential: async (id, body) => {
    const response=await axios.put(base+'/credentials/'+id,body,options());
    if(response.data.status!=='SUCCESS')throw new Error(response.data.message || 'Unable to save credential');
    return response.data.data;
  },
  outlets: () => get('/outlets'),
  list: (tab, params) => get('/' + tab, params),
  detail: id => get('/orders/' + id),
  log: id => get('/logs/' + id)
};
